"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'sso/v1';

var SingleSignonAPI =
/*#__PURE__*/
function () {
  function SingleSignonAPI() {
    (0, _classCallCheck2.default)(this, SingleSignonAPI);
  }

  (0, _createClass2.default)(SingleSignonAPI, null, [{
    key: "getSamlSettings",
    value: function getSamlSettings() {
      return _apiClient.default.get(API_BASE + "/saml/settings/sso-config");
    }
  }, {
    key: "getSsoEnabled",
    value: function getSsoEnabled() {
      return _apiClient.default.get(API_BASE + "/saml/settings/sso-status");
    }
  }, {
    key: "confirmSaml",
    value: function confirmSaml() {
      return _apiClient.default.post(API_BASE + "/saml/settings/confirm");
    }
  }, {
    key: "updateSamlSettings",
    value: function updateSamlSettings(data) {
      return _apiClient.default.post(API_BASE + "/saml/settings/configure", {
        data: data
      });
    }
  }, {
    key: "deleteSamlSettings",
    value: function deleteSamlSettings() {
      return _apiClient.default.delete(API_BASE + "/saml/settings");
    }
  }, {
    key: "updateSamlRequirement",
    value: function updateSamlRequirement(data) {
      return _apiClient.default.post(API_BASE + "/saml/settings/required", {
        data: data
      });
    }
  }, {
    key: "setExemptUsers",
    value: function setExemptUsers(data) {
      return _apiClient.default.put(API_BASE + "/user-exemptions", {
        data: data
      });
    }
  }]);
  return SingleSignonAPI;
}();

exports.default = SingleSignonAPI;
module.exports = exports.default;